// Offers (spec/dashboard.md section 7.3): the offers workspace — the offers and the offer groups in one list, the selected
// one in sections on the right (docs/UI-POLISH.md §2 "Offers").
import { OffersWorkspace } from './OffersWorkspace';

export function OffersPage() {
  return <OffersWorkspace />;
}
